import {HttpClient} from "@angular/common/http";
import {SharedService} from "./shared.service";
import {RemedialSearchCriteria} from "../_models/RemedialSearchCriteria";
import {PagedResponse} from "../_models";
import {Remedial} from "../_models/Remedial";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {HelpDet} from "../_models/HelpDet";
import {CreateRemedialDto} from "../_models/RemedialCreationRequest";
import {UserSearchCriteria} from "../_models/UserSearchCriteria";
import {User} from "../_models/User";

@Injectable({providedIn: 'root'})
export class RemedialService extends SharedService {
  constructor(httpClient: HttpClient) {
    super(httpClient)
  }

  searchRemedials(remedialSearchCriteria: RemedialSearchCriteria): Observable<PagedResponse<Remedial>> {
    return this.httpClient.post<PagedResponse<Remedial>>('/api/remedials/search', remedialSearchCriteria);
  }

  getRemedialItems() : Observable<HelpDet[]> {
    return this.httpClient.get<HelpDet[]>('/api/remedials/remedialitems')
  }

  getRemedialLocations() : Observable<HelpDet[]> {
    return this.httpClient.get<HelpDet[]>('/api/remedials/remediallocations')
  }

  createRemedial(remedial: CreateRemedialDto): Observable<Remedial> {
    return this.httpClient.post<Remedial>('/api/remedials/create', remedial);
  }

  searchUsers(criteria: UserSearchCriteria) {
    return this.httpClient.post<User[]>('/api/remedials/searchusers', criteria);
  }

  getRemedial(id: string): Observable<Remedial>{
    return this.httpClient.get<Remedial>('/api/remedials/' + id);
  }

  updateRemedial(remedial: Remedial, images: string[]) {
    return this.httpClient.post<Remedial>('/api/remedials/update', {remedial, images});
  }
}
